import React, { Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { RequestModal } from "../../../common/modal/modal.component";
import Translation from "../../../common/translation/translation.component";
import "./create-request.component.css";
import { LoadingText } from "../../../common/loading-text/loading-text-component";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { REQUEST_TYPE, REQUEST_TYPES_ID } from "../../../../constants/external-constants";
export class CreateRequest extends Component {
    constructor(props) {
        super();
    }

    render() {
        const { requestTypes, isLoaded, openRequestModal, closeAction } = this.props;

        let noAccess = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MyRequestsRW]);
        let button;

        if ( isLoaded ) {
            button = (
                <Dropdown.Item key="category">
                    {/*'Category'*/}
                </Dropdown.Item>
            );

            if (requestTypes.Wireless && Object.keys(requestTypes.Wireless).length) {
                var actionsAndRequests = null;
                var newRequests = null;

                if (requestTypes.Wireless.ActionsAndRequests.length) {
                    actionsAndRequests = [
                        <span key="actions-and-sim-requests">
                            {<Translation translationKey="actions_and_sim_requests" />}
                        </span>,
                        requestTypes.Wireless.ActionsAndRequests.map((requestType) => {
                            if (requestType.RequestTypeID === REQUEST_TYPES_ID.intlRoamingAccess) {
                                requestType.RequestType = REQUEST_TYPE.InternationalAccess;
                                return (
                                    <div
                                        key={'createRequest-' + requestType.RequestTypeID}
                                        data-request-type-id={requestType.RequestTypeID}
                                        onClick={() => openRequestModal(requestType.RequestTypeID, requestType.RequestType)}
                                        className="indented"
                                    >
                                        {requestType.RequestType}
                                    </div>
                                );
                            }
                            else {
                                return (
                                    <div
                                        key={'createRequest-' + requestType.RequestTypeID}
                                        data-request-type-id={requestType.RequestTypeID}
                                        onClick={() => openRequestModal(requestType.RequestTypeID, requestType.RequestType)}
                                        className="indented"
                                    >
                                        {requestType.RequestType}
                                    </div>
                                );
                            }
                        }),
                    ];
                }

                if (requestTypes.Wireless.NewRequests.length) {
                    newRequests = [
                        <span key="new-requests">
                            {<Translation translationKey="new" />}
                        </span>,
                        requestTypes.Wireless.NewRequests.map((requestType) => {
                            return (
                                <div
                                    key={'createRequest-' + requestType.RequestTypeID}
                                    data-request-type-id={requestType.RequestTypeID}
                                    onClick={() => openRequestModal(requestType.RequestTypeID, requestType.RequestType)}
                                    className="indented"
                                >
                                    {requestType.RequestType}
                                </div>
                            );
                        }),
                    ];
                }

                var wireless = (
                    <Dropdown.Item key="wireless" className="indented with-children">
                        {<Translation translationKey="wireless" />}<i className="fa fa-chevron-right" />
                        <div className="create-request-children">
                            {actionsAndRequests}
                            {newRequests}
                        </div>
                    </Dropdown.Item>
                );

                button = [button, wireless];
            }

            if (requestTypes.Wireline && Object.keys(requestTypes.Wireline).length) {
                var actionsAndRequests = null;
                var newRequests = null;

                if (requestTypes.Wireline.ActionsAndRequests) {
                    actionsAndRequests = [
                        <span key="actions-and-sim-requests">
                            {<Translation translationKey="actions_and_requests" />}
                        </span>,
                        requestTypes.Wireline.ActionsAndRequests.map((requestType) => {
                            return (
                                <div
                                    key={'createRequest-' + requestType.RequestTypeID}
                                    data-request-type-id={requestType.RequestTypeID}
                                    onClick={() => openRequestModal(requestType.RequestTypeID, requestType.RequestType)}
                                    className="indented"
                                >
                                    {requestType.RequestType}
                                </div>
                            );
                        }),
                    ];
                }

                if (requestTypes.Wireline.NewRequests.length) {
                    newRequests = [
                        <span key="new-requests">
                            {<Translation translationKey="new" />}
                        </span>,
                        requestTypes.Wireline.NewRequests.map((requestType) => {
                            return (
                                <div
                                    key={'createRequest-' + requestType.RequestTypeID}
                                    data-request-type-id={requestType.RequestTypeID}
                                    onClick={() => openRequestModal(requestType.RequestTypeID, requestType.RequestType)}
                                    className="indented"
                                >
                                    {requestType.RequestType}
                                </div>
                            );
                        }),
                    ];
                }

                var wireline = (
                    <Dropdown.Item key="wireline" className="indented with-children">
                        {<Translation translationKey="wireline" />}<i className="fa fa-chevron-right" />
                        <div className="create-request-children">
                            {actionsAndRequests}
                            {newRequests}
                        </div>
                    </Dropdown.Item>
                );

                 button = [button, wireline];               
            }
        } else {
            button = <LoadingText/>;
        }

        return (
            <div className="c-r-dropdown create-request-container">
                <RequestModal ref={this.OrderRequestModal} data={this.props.data} isLoaded={false} closeAction={closeAction} />
                {
                    noAccess ? null :
                    <DropdownButton title={<Translation translationKey="create_request" />}>
                        {button}
                    </DropdownButton>
                }
           </div>
        )
    }
}

export default CreateRequest;
